import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = {
  key: 0,
  class: "grid items-start grid-cols-12 gap-6"
}
const _hoisted_3 = { class: "col-span-12 p-4" }
const _hoisted_4 = { class: "mb-3 font-medium text-neutral-300" }
const _hoisted_5 = {
  key: 0,
  class: "text-neutral-600"
}
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 1,
  class: "grid grid-cols-12 gap-6"
}
const _hoisted_8 = { class: "col-span-12" }

import { ref, watch } from "vue";
import CkEditor from '@/components/inputs/CKEditor.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MinutesMeetingTab',
  props: {
    form: {
        type: Object,
        required: true
    },
    isView: {
        type: Boolean,
        default: false
    }
},
  emits: ['update:form'],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;
const form = ref(props.form)
watch(
    form.value,
    () => {
        emit('update:form', form.value);
    }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.isView)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, _toDisplayString(form.value.date_time_formatted), 1),
            (!form.value.meeting_minutes)
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, "No minutes of the meeting yet."))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  innerHTML: form.value.meeting_minutes,
                  class: "frm-description"
                }, null, 8, _hoisted_6))
          ])
        ]))
      : _createCommentVNode("", true),
    (!__props.isView)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(CkEditor, {
              modelValue: form.value.meeting_minutes,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.meeting_minutes) = $event))
            }, null, 8, ["modelValue"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})